import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';

import { connect } from 'react-redux';
import { resetPassword2, checkToken, setTokenStatus, setPasswordChanged } from 'actions/resetPassword';
import { push } from 'react-router-redux';
import { FORM_ERROR } from 'final-form';

import ResetPasswordForm from 'components/forms/ResetPasswordForm';
import Logo from 'components/Logo';
import ThemeToggle from 'components/ThemeToggle';
import { Link } from 'react-router';

const messages = defineMessages({
  NEW_PASSWORD: {
    id: 'ResetPassword.NEW_PASSWORD',
    defaultMessage: 'Neues Passwort vergeben',
  },
  NEW_PASSWORD_DESC: {
    id: 'ResetPassword.NEW_PASSWORD_DESC',
    defaultMessage: 'Bitte geben Sie Ihr neues Passwort ein.',
  },
  BACK: {
    id: 'ResetPassword.BACK',
    defaultMessage: 'Zurück zum Login',
  },
});

class ResetPassword extends React.PureComponent {
    componentWillMount() {
        this.props.checkToken(this.props.params.userId, this.props.params.token);
    }

    render() {
      const { intl: { formatMessage } } = this.props;
      return (
          <div className="anonymous-container" style={{ minHeight: '100vh', width: '100%', position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 20px', background: 'var(--bg-color)' }}>
              <div className="anonymous-card-wrapper" style={{ width: '100%', maxWidth: '480px' }}>
                  <div className="anonymous-card" style={{ backgroundColor: 'var(--panel-bg)', borderRadius: '32px', boxShadow: 'var(--glass-shadow)', border: '1px solid var(--panel-border)', overflow: 'hidden' }}>
                      {/* Logo Header */}
                      <div className="anonymous-header" style={{ position: 'relative', padding: '32px 0', borderBottom: '1px solid var(--panel-border)', backgroundColor: 'var(--panel-bg)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          <Logo large />
                          <div className="anonymous-theme-toggle">
                              <ThemeToggle />
                          </div>
                      </div>

                      {/* Content */}
                      <div style={{ padding: '40px 48px' }}>
                          <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: 'rgba(59, 130, 246, 0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '24px' }}>
                              <i className="fa fa-lock" style={{ fontSize: '28px', color: '#3b82f6' }} aria-hidden="true" />
                          </div>
                          <h1 style={{ margin: '0 0 8px 0', fontSize: '24px', fontWeight: 'bold', color: 'var(--text-color)' }}>
                              {formatMessage(messages.NEW_PASSWORD)}
                          </h1>
                          <p style={{ color: 'var(--text-muted)', fontSize: '15px', lineHeight: '1.6', marginBottom: '32px' }}>
                              {formatMessage(messages.NEW_PASSWORD_DESC)}
                          </p>
                          <ResetPasswordForm onSubmit={this.props.resetPassword} />
                          <div style={{ marginTop: '24px', textAlign: 'center' }}>
                              <Link
                                  to="/login"
                                  style={{ color: 'var(--text-muted)', textDecoration: 'none', fontWeight: '500', display: 'inline-flex', alignItems: 'center', gap: '8px' }}
                                  onMouseEnter={(e) => e.currentTarget.style.color = '#3b82f6'}
                                  onMouseLeave={(e) => e.currentTarget.style.color = 'var(--text-muted)'}
                              >
                                  <i className="fa fa-arrow-left" aria-hidden="true" /> {formatMessage(messages.BACK)}
                              </Link>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      );
    }
}

export default connect(null,
  (dispatch, props) => ({
    resetPassword: async formData => {
      const { userId, token } = props.params;
      const data = await resetPassword2(
        userId,
        token,
        formData,
      );
      if (data.response) {
        dispatch(setPasswordChanged(true));
        dispatch(push('/resetPassword/success'));
      } else {
        return { [FORM_ERROR]: data.error[Object.keys(data.error)[0]] };
      }
    },
    checkToken: (userId, token) => checkToken(userId, token).then(
      () => {
        dispatch(setTokenStatus(true));
      },
      () => {
        dispatch(setTokenStatus(false));
        dispatch(push('/resetPassword/tokenError'));
      }
    ),
  })
)(injectIntl(ResetPassword));
